<div class="payment-template" style="
    width: 100%;
    height: 100%;
    color: #3a6183;
    background: #f3f3f3;
    padding: 32px;
    font-family: 'system-ui';
    border-radius: 15px;
  ">
  <div class="title" style="font-size: 40px; font-weight: bolder; margin-bottom: 32px">
    Course Purchased!
  </div>
  <div class="body" style="display: flex">
    <div class="left" style="
        display: flex;
        width: 70%;
        background-color: #ffffff;
        padding: 32px;
        border-radius: 15px;
      ">
      <div class="inner-left" style="margin-right: 32px">
        <div class="icon" style="width: 200px; height: 200px">
          <img style="width: 100%" src="../../../assets/images/header-logo.png" alt="" />
        </div>

        <button style="
            background: rgb(255, 174, 0);
            border: none;
            border-radius: 15px;
            padding: 0.5rem;
            font-weight: bold;
            color: white;
            height: 40px;
            margin-left: 33%;
          ">
          <a href="https://thelaboratorymatters.com/login" style="color: 'white'; text-decoration: 'none'">
            Reset
          </a>
        </button>
      </div>
      <div class="inner-right">
        <div class="text1" style="font-size: 20px; margin: 16px 0;">Hi Vignesh,</div>
        <div class="text2" style="font-size: 20px; font-weight: bold; margin: 0 0 24px 0">
          We have received your payment receipt.

        </div>
        <div class="text3" style="margin-bottom: 30px">
          You will gain access to your
          course within <span style="font-weight: bold;">48 hours</span>.
          Access to your course will expire in <span style="font-weight: bold;">4 weeks(date)</span>.
          You can however, watch the course multiple times during these 4 weeks. In case, you have any clarification
          or queries, you can write to me at <span style="font-weight: bold;">Drrani.r@thelaboratorymatters.com</span>. I will send you my response
          within 7 working days.
          Courses can be viewed from your
          <span style="color: rgb(255, 174, 0)">
            <a href="https://thelaboratorymatters.com/login" style="color: 'rgb(255,175,0)'; text-decoration: 'none'">
              dashboard
            </a> </span>!
        </div>
        <div class="text4">
          <button style="
              background: #f3f3f3;
              border: none;
              border-radius: 15px;
              padding: 8px 8px;
              color: #3a6183;
            ">
            <a href="https://thelaboratorymatters.com/login" style="color: '#3a6183'; text-decoration: 'none'">
              Continue your learning journey!
            </a>
          </button>
        </div>
      </div>
    </div>
    <div class="right" style="width: 30%">
      <img style="width: 100%" src="../../../assets/images/story-image.png" alt="" />
    </div>
  </div>
</div>